import { cn } from "@design-system/utils";
import { trans } from "@mongez/localization";
import {
  certificateRankText,
  rankMedal,
} from "../utils/certificate-presentation";

type RankBadgeProps = {
  rank?: number | null;
  rankLabel?: string | null;
  size?: "sm" | "md";
  className?: string;
};

/**
 * Medal chip: 🥇 / 🥈 / 🥉 for the top three, 🏅 «المركز N» otherwise.
 * Renders nothing for unranked certificates.
 *
 * @example
 * <RankBadge rank={1} rankLabel="المركز الأول" />
 */
export function RankBadge({
  rank,
  rankLabel,
  size = "md",
  className,
}: RankBadgeProps) {
  const medal = rankMedal(rank);

  if (!medal) return null;

  const text = certificateRankText(rank, rankLabel, (value) =>
    trans("certificates.rank", { rank: value }),
  );

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-black ring-1",
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm",
        medal.className,
        className,
      )}
    >
      <span aria-hidden="true">{medal.emoji}</span>
      <span>{text}</span>
    </span>
  );
}
